<template>
  <svg
    width="15"
    height="27"
    viewBox="0 0 15 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.70324 1.32153H5.29172C5.04823 1.32153 4.85059 1.51904 4.85059 1.76236C4.85059 2.00569 5.04823 2.20319 5.29172 2.20319H9.70324C9.94674 2.20319 10.1444 2.00569 10.1444 1.76236C10.1444 1.51904 9.94674 1.32153 9.70324 1.32153Z"
    />
    <path
      d="M12.7934 1.32153H12.3523C12.1088 1.32153 11.9111 1.51904 11.9111 1.76236C11.9111 2.00569 12.1088 2.20319 12.3523 2.20319H12.7934C13.0369 2.20319 13.2345 2.00569 13.2345 1.76236C13.2345 1.51904 13.0369 1.32153 12.7934 1.32153Z"
    />
    <path
      d="M8.04784 22.4824H6.95247C6.28149 22.4824 5.73535 23.0282 5.73535 23.6987V23.9116C5.73535 24.5822 6.28149 25.1275 6.95206 25.1275H8.04743C8.71841 25.1275 9.26455 24.5822 9.26455 23.9116V23.6987C9.26455 23.0282 8.71841 22.4824 8.04784 22.4824ZM8.38227 23.9116C8.38227 24.0959 8.2323 24.2458 8.04789 24.2458H6.95247C6.76765 24.2458 6.61762 24.0959 6.61762 23.9116V23.6987C6.61762 23.514 6.7676 23.3641 6.95247 23.3641H8.04743C8.2323 23.3641 8.38227 23.514 8.38227 23.6987V23.9116Z"
    />
    <path
      d="M13.4049 0H1.59477C0.715548 0 0 0.715051 0 1.59366V24.8572C0 25.7358 0.715548 26.4508 1.59477 26.4508H13.4044C14.2837 26.4508 14.9992 25.7358 14.9992 24.8576V1.59366C14.9993 0.715051 14.2837 0 13.4049 0ZM14.1169 24.8572C14.1169 25.2495 13.7975 25.5691 13.4049 25.5691H1.59477C1.20171 25.5691 0.882325 25.2495 0.882325 24.8576V1.59366C0.882325 1.20129 1.20171 0.881712 1.59477 0.881712H13.4044C13.7975 0.881712 14.1169 1.20134 14.1169 1.59366V24.8572H14.1169Z"
    />
    <path
      d="M14.558 2.6438H0.441137C0.197641 2.6438 0 2.8413 0 3.08463V21.6002C0 21.8435 0.197641 22.041 0.441137 22.041H14.5581C14.8016 22.041 14.9992 21.8435 14.9992 21.6002V3.08463C14.9992 2.8413 14.8016 2.6438 14.558 2.6438ZM14.1169 21.1594H0.882273V3.52551H14.1169V21.1594Z"
    />
  </svg>
</template>

<script>
export default {
  name: "CellphoneIcon",
};
</script>
